import { render, staticRenderFns } from "./WeightWashNew.vue?vue&type=template&id=095dcf4a"
import script from "./WeightWashNew.vue?vue&type=script&lang=js"
export * from "./WeightWashNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports